import { connect } from 'react-redux'
import { IStoreState } from '../../types/index'
import RemoveAccommodationsModal from 'src/components/global-settings/RemoveAccommodationsModal'
import { getVehicleCreateAccomodations, removeVehicleAccomodations } from 'src/state/actions/vehicles'
import { getVehicleAccomodation } from 'src/state/selectors'

const mapStateToProps = (state: IStoreState, ownProps: any): any => {
  return {
    id: ownProps.match.params.id,
    setting: getVehicleAccomodation(ownProps.match.params.id, state)
  }
}

const mapDispatchToProps = (dispatch: any): any => {
  return {
    removeVehicleAccomodation: (id: string) => {
      return new Promise((approve, reject) => {
        dispatch(removeVehicleAccomodations(id)).then(() => {
          dispatch(getVehicleCreateAccomodations()).then(() => {
            approve()
          })
        })
      })
    },
    getVehicleCreateAccomodations: () => dispatch(getVehicleCreateAccomodations())
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RemoveAccommodationsModal)



// WEBPACK FOOTER //
// ./src/containers/global-settings/RemoveAccommodationsModal.ts